
import { GroupType, GroupTypePairs, toString as toStringGroupType } from "../../../types/models/GroupType.d";





import { useGetMembersGroupQuery, useGetMembersGroupListQuery, useGetMembersGroupPresentationQuery } from "../../../../auth/apis/MembersGroup.api";
import { MembersGroupNameDisplay, default as MembersGroupName } from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupName";
import { toString as toStringMembersGroup, PrimaryMembersGroup } from "../../../../auth/types/models/MembersGroup";
import React from "react";
import {
    Box,
    TextField,
    InputAdornment,
    IconButton,
    Container,
    Stack,
    Button,
    FormControl,
    Divider,
} from "@mui/material";
import Search from "@mui/icons-material/Search";
import Refresh from "@mui/icons-material/Refresh";
import Clear from "@mui/icons-material/Clear";
import RemoveCircle from "@mui/icons-material/RemoveCircle";
import AddCircleOutline from "@mui/icons-material/AddCircleOutline";
import ManageSearch from "@mui/icons-material/ManageSearch";
import { object, string, number, boolean, date, coerce, TypeOf, array } from 'zod';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import * as crudgen from "../../../../share";
import {formatDateTime, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import {useDebounce} from "react-use";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import {useDispatch} from "react-redux";
import useSearch from "../../../../hooks/useSearch";
import { Trans } from "@lingui/react/macro";
import { t, msg } from "@lingui/core/macro";




export const initialFormStateFn = () => { return {
    
    
    
        membersGroupId: [],
        
    
} }

export const formObject = {
    
        name: string()
        .trim()
        .nullish(),
        
        
    
        scopeGroupContext: string()
        .trim()
        .nullish(),
        
        
    
        membersGroupId: array(string()
            .nullish()),
        
        
        membersGroupIdInclude: boolean().default(false),
        
    
};

export const formSchema = object(formObject);

export type FormInput = TypeOf<typeof formSchema>;



type IProps = {
    prefix?: string;
    setSearchInputValue: (search: string) => void;
    searchInputAdvanced: any;
    setSearchInputAdvanced: (any) => void;
    query: any;
    refetch: () => void;
}

const ScopeGroupListSearch = (props: IProps) => {
    
    const {advancedSearch, search, updateSearch} = useSearch('ScopeGroup')
    
    const [advanced, setAdvanced] = React.useState(advancedSearch);
    
    const {prefix = '', query} = props;
    
    const methods = useForm<FormInput>({
        resolver: zodResolver(formSchema),
        defaultValues: advanced ? search : initialFormStateFn()
    });

    const {
        reset,
        watch,
        handleSubmit,
        formState: { isSubmitSuccessful },
    } = methods;
    
    
    const [, setMembersGroupInputValue, membersGroupInputTerm] = useSearchDebounce();
    const { data: membersGroupList = {
        items: [],
        totalItems: 0,
        page: 0,
        pageSize: 12,
        numPages: 0
    },
        isLoading: getMembersGroupListLoading,
        isFetching: getMembersGroupListFetching, 
    } = useGetMembersGroupPresentationQuery({
        list: {
            page: 0,
            pageSize: 12,
        },
        filter: {
            hierarchyName: membersGroupInputTerm || '',
                    hierarchyNameOr: true,
                    },
    })
    
    
    
    const cancelSearch = React.useCallback((e: any) => {
        e.stopPropagation()
        props.setSearchInputAdvanced(undefined)
        setAdvanced(false)
    })
    
    const onAdvancedSubmitHandler: SubmitHandler<FormInput> = (values, e: any) => {
        props.setSearchInputAdvanced(values)
    };

    const membersGroupIdInclude = watch(prefix + 'membersGroupIdInclude');

    React.useEffect(() => {
        if (!advancedSearch) {
            props.setSearchInputValue(search)
        }
    }, []);

    const [advancedFormValues, setAdvancedFormValues] = React.useState(advanced ? search : initialFormStateFn())

    const [, cancelAdvancedFormValues] = useDebounce(() => {
        if (advanced) {
            handleSubmit(onAdvancedSubmitHandler)()
            updateSearch(advanced, advancedFormValues)
        }
    }, DEBOUNCE_TIME, [advancedFormValues, advanced])

    React.useEffect(() => {
        const subscription = watch((values) => {
            setAdvancedFormValues(values)
        });
        return () => {
            cancelAdvancedFormValues()
            subscription.unsubscribe()
        }
    }, [watch, cancelAdvancedFormValues]);
        
    if (!advanced)
    return (<Box
        component="form"
        onSubmit={(e) => {e?.preventDefault()}}
        noValidate
        sx={ { '& > :not(style)': { m: 1, width: '100%', padding: '1em' } } }
        autoComplete="off"
        data-testid="ScopeGroup-search-form"
    >
        <TextField
            defaultValue={ !advancedSearch ? search : '' }
            label={t`Search (by Name)`}
            onChange={ (event) => {
                props.setSearchInputValue(event.target.value)
                updateSearch(false, event.target.value)
            } }
            variant="standard"
            slotProps={ {
                input: {
                    startAdornment: (
                        <InputAdornment position="start">
                            <Search />
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                onClick={() => {
                                    props.setSearchInputValue('')
                                    updateSearch(false, '')
                                } }
                                edge="end"
                            >
                                <Clear />
                            </IconButton>
                            <IconButton
                                onClick={() => setAdvanced(!advanced)}
                                edge="end"
                            >
                                <ManageSearch />
                            </IconButton>
                            
                            <IconButton
                                onClick={props.refetch}
                                edge="end"
                            >
                                <Refresh />
                            </IconButton>
                        </InputAdornment>
                    ),
                },
            } }
        />
    </Box>)
    if (advanced)
        return (<Container sx={ { marginBottom: '1em' } }>
            <FormProvider {...methods}>
                <Box
                    component='form'
                    onSubmit={handleSubmit(onAdvancedSubmitHandler)}
                    noValidate
                    data-testid="ScopeGroup-advanced-search-form"
                >
                    <FormControl fullWidth size="small">
                        
        
            
            <crudgen.FormInput
                    
                    name={ prefix + 'name' }
                    label={t`Name`}
                    clearable={true}
                    
                    
                    type='text'
                    
            />
            
        
    

                        
        
            
            <crudgen.FormInput
                    
                    name={ prefix + 'scopeGroupContext' }
                    label={t`Scope Group Context`}
                    clearable={true}
                    
                    
                    type='text'
                    
            />
            
        
    

                        <Box sx={ {display: 'flex'} }>
        
        <crudgen.AsyncFormSelect
                
                name={ prefix + 'membersGroupId' }
                optionsLoading={ getMembersGroupListLoading || getMembersGroupListFetching }
                label={t`Members Group`}
                options={ membersGroupList.items }
                valueMap={ (id) => useGetMembersGroupQuery(PrimaryMembersGroup.fromId(id), {skip: !id}) }
                optionLabelMap={ toStringMembersGroup }
                onInputChange={ setMembersGroupInputValue }
                renderOption={(optionProps, option, { inputValue }) => {
                    const { key, ...filteredOptionProps } = optionProps;
                    return (<li key={key} {...filteredOptionProps}><MembersGroupNameDisplay data={option}/></li>)
                } }
                disabled={ !!membersGroupIdInclude }
                
                renderTags={(value: readonly string[], getTagProps) =>
                    value.map((option: any, index: number) => {
                        const { key, ...tagProps } = getTagProps({ index })
                        return (
                            <crudgen.SelectChip key={key} {...tagProps}>
                                <MembersGroupName id={option}/>
                            </crudgen.SelectChip>
                        );
                    })
                }
                multiple
                
            
        />
        
    
<crudgen.FormCheckbox
        name={ prefix + 'membersGroupIdInclude' }
        icon={<AddCircleOutline />}
        checkedIcon={<RemoveCircle />}
    />
</Box>
                        
                        
                        <Stack direction="row" spacing={1}>
                            <Button size="small"  variant="outlined" color="primary" type='submit' sx={ {display: 'none'} }>
                                <Search /> <Trans>Search</Trans>
                            </Button>
                            <Button size="small"  variant="outlined" color="primary" onClick={props.refetch}>
                                <Refresh /> <Trans>Refresh</Trans>
                            </Button>
                            <Button size="small" variant="outlined" onClick={cancelSearch} color="inherit">
                                <Trans>Cancel</Trans>
                            </Button>
                        </Stack>
                    </FormControl>
                </Box>
            </FormProvider>
        </Container>)
    
}

export default ScopeGroupListSearch;
